<template>
    <div class="d-flex justify-center align-center">
        <Terms class="terms"/>
    </div>
</template>

<script>
import Terms from '@/components/Terms.vue'
export default {
    components: {
        Terms
    }
}
</script>

<style lang="scss" scoped>
.terms{
    padding: 50px 100px;

    @media only screen and (max-width: 600px) {
        padding: 10px 10px;
    }

}
</style>